/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagephaseupcoming3Inputs */

const en_ticketpagephaseupcoming3 = /** @type {(inputs: Ticketpagephaseupcoming3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const de_ticketpagephaseupcoming3 = /** @type {(inputs: Ticketpagephaseupcoming3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommend`)
};

/**
* | output |
* | --- |
* | "Upcoming" |
*
* @param {Ticketpagephaseupcoming3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagephaseupcoming3 = /** @type {((inputs?: Ticketpagephaseupcoming3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagephaseupcoming3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagephaseupcoming3(inputs)
	return de_ticketpagephaseupcoming3(inputs)
});
export { ticketpagephaseupcoming3 as "ticketPagePhaseUpcoming" }